<template>
  <ArticleLayout class="terms-conditions-container" title="TERMS & CONDITIONS">
    <iframe src="/pdfjs/web/viewer.html?file=/terms-conditions.pdf" />
  </ArticleLayout>
</template>

<script>
import ArticleLayout from '~/components/ArticleLayout'
export default {
  layout: 'default',
  head() {
    return {
      title: 'terms conditions'
    }
  },
  components: {
    ArticleLayout
  },
  asyncData() {
    return {}
  }
}
</script>

<style lang="less">
.terms-conditions-container {
  .main-container {
    padding: 0;

    iframe {
      width: 100%;
      height: 1000px;
      border: none;
      position: relative;
      z-index: 2;
    }
  }
}
</style>
